<template>
  <a-space direction="vertical" style="width: 100%">
    <a-button type="primary" @click="handleAdd">添加回访记录</a-button>
    <a-table :columns="columns" :data="props.paramsData">
      <template #createtime="{ record }">
        <!-- {{ formatTimestamp(Number(record.createtime), false) }} -->
        {{ record.createtime || '-' }}
      </template>
      <template #result_level="{ record }">
        {{ getResultLevelText(record.result_level) }}
      </template>
    </a-table>
  </a-space>
  <FollowUpRecordModal
    v-model:visible="recordModalVisible"
    mode="add"
    :record="modalParams"
    @submit="handleSubmit"
    @cancel="handleCancel"
  />
</template>

<script lang="ts" setup>
  import { ref, reactive } from 'vue';
  import FollowUpRecordModal from '@/components/follow-up-record-modal/index.vue';
  import { FollowUpRecordData } from '@/components/follow-up-record-modal/types';
  import { addFollowUp } from '@/api/followup';
  import { Message } from '@arco-design/web-vue';

  const recordModalVisible = ref(false);

  const props = defineProps<{
    paramsData: {
      user_id: number;
      reminder_id: number;
      result_level: number | string;
      content: string;
      createtime?: string;
    }[];
    userId?: number;
    reminderId?: number;
  }>();

  const modalParams = ref<FollowUpRecordData>({
    user_id: 0,
    reminder_id: 0,
    result_level: '',
    content: '',
  });

  const emit = defineEmits<{
    (e: 'update:data', data: any): void;
  }>();

  const columns = ref([
    {
      title: '回访结果',
      dataIndex: 'result_level',
      slotName: 'result_level',
    },
    {
      title: '回访内容',
      dataIndex: 'content',
    },
    {
      title: '回访时间',
      dataIndex: 'createtime',
      slotName: 'createtime',
    },
  ]);

  const handleAdd = () => {
    // 优先使用props中的userId和reminderId，如果没有则尝试从paramsData中获取
    let { userId, reminderId } = props;

    if (!userId && props.paramsData && props.paramsData.length > 0) {
      userId = props.paramsData[0].user_id;
    }

    if (!reminderId && props.paramsData && props.paramsData.length > 0) {
      reminderId = props.paramsData[0].reminder_id;
    }

    // 如果仍然没有必要的参数，则无法添加记录
    if (!userId || !reminderId) {
      console.warn('缺少必要的参数：userId 或 reminderId');
      return;
    }

    modalParams.value = {
      user_id: userId,
      reminder_id: reminderId,
      result_level: '',
      content: '',
    };
    recordModalVisible.value = true;
  };

  const handleSubmit = async (data: any) => {
    // console.log('提交数据:', data);
    try {
      await addFollowUp(data);
      Message.success('添加回访记录成功');
      // 需要通知父组件更新数据
      emit('update:data', props.paramsData);
      recordModalVisible.value = false;

      // 重新获取回访记录数据
      await refreshTableData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    modalParams.value = {
      user_id: 0,
      reminder_id: 0,
      result_level: '',
      content: '',
    };
    recordModalVisible.value = false;
  };

  // 刷新表格数据
  const refreshTableData = async () => {
    try {
      // 这里可以调用API重新获取数据，或者通过emit通知父组件刷新
      // 由于这个组件没有直接的API调用，我们通过emit通知父组件
      emit('update:data', 'refresh');
    } catch (error) {
      console.error('刷新数据失败:', error);
    }
  };

  const getResultLevelText = (level: string | number) => {
    const levelMap: Record<string, string> = {
      '1': '有效一级',
      '2': '有效二级',
      '3': '有效三级',
      '-1': '无效一级',
      '-2': '无效二级',
    };
    return levelMap[String(level)] || '-';
  };
</script>

<script lang="ts">
  export default {
    name: 'SecondLevelTable',
  };
</script>
